export default {
  BASE_URL: '/cms/tag',
  api: [
    {
      name: 'list',
      method: 'POST',
      desc: '获取标签库列表',
      path: '/list'
    },
    {
      name: 'deleteTag',
      method: 'GET',
      desc: '删除标签',
      path: '/deleteTag',
      append: true
    },
    {
      name: 'addTag',
      method: 'POST',
      desc: '新增编辑标签',
      path: '/addTag'
    },
    {
      name: 'checkTagName',
      method: 'POST',
      desc: '检测标签名称是否重复',
      path: '/checkTagName'
    },
    {
      name: 'changeStatus',
      method: 'POST',
      desc: '更改启用状态',
      path: '/changeStatus'
    },
    {
      name: 'getTag',
      method: 'GET',
      desc: '获取标签选项',
      path: '/getTag'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/cms/label.js